import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { IOption } from 'src/app/shared/models/common.model'
import { IGetTransactions } from 'src/app/shared/models/Transaction.model'
import { IOuterTableRef, TableColumnDefs } from 'src/app/shared/components/common/new-table/table.model'

export interface FormValues {
  clientId: string | null
  accountIds: string[] | null
  checkNumber: string
  amount: string
  date: string[]
}

export interface VoidChecksContextProps {
  form: UseFormReturn<FormValues>
  clientOptions: IOption[]
  accountOptions: IOption[]
  loading: boolean
  searchLoading: boolean
  disabled: boolean
  onSubmit: (values: FormValues) => Promise<void>
  onReset: () => void
  // Results data
  transactionData: IGetTransactions.Response
  hasSearched: boolean
  outerTableRef: React.RefObject<IOuterTableRef>
  handleSearch: (payload: any) => Promise<void>
  reloadTable: () => Promise<void>
  handleDownload: (payload: any) => Promise<any>
  currentPage: number
  pageSize: number
}

export const VoidChecksContext = React.createContext<VoidChecksContextProps>({
  form: null as any,
  clientOptions: [],
  accountOptions: [],
  loading: false,
  searchLoading: false,
  disabled: false,
  onSubmit: () => Promise.resolve(),
  onReset: () => {},
  transactionData: { items: [], total: 0 },
  hasSearched: false,
  outerTableRef: { current: null },
  handleSearch: () => Promise.resolve(),
  reloadTable: () => Promise.resolve(),
  handleDownload: () => Promise.resolve(),
  currentPage: 1,
  pageSize: 50,
})

export const useVoidChecksContext = () => React.useContext(VoidChecksContext)
